import React from "react";

export const ProductDetailsAccordion = ({ fabric, fit }) => {
  const sections = [
    ["Fabric", fabric],
    ["Fit", fit],
    ["Care & Origin", "Cold wash, lay flat to dry. Cut and sewn in Portugal."],
  ];
  return (
    <div className="mt-10 border-t border-[#1a1814]/10 divide-y divide-[#1a1814]/10">
      {sections.map(([h, c]) => (
        <details key={h} className="py-5 group" data-testid={`detail-${h.replace(/\s/g, '-').toLowerCase()}`}>
          <summary className="flex justify-between cursor-pointer micro-label">
            <span>{h}</span><span className="text-[#1a1814]/40 group-open:rotate-45 transition-transform">+</span>
          </summary>
          <p className="text-sm text-[#1a1814]/70 mt-3 leading-relaxed">{c}</p>
        </details>
      ))}
    </div>
  );
};
